<p-dialog
  [(visible)]="showDialog"
  [modal]="true"
  [closable]="!isSuccess"
  [closeOnEscape]="!isSuccess"
  [dismissableMask]="!isSuccess"
  [style]="{ margin: '0 2rem', minWidth: '300px' }"
  [draggable]="false"
  styleClass="deactivate-modal"
  (onHide)="closeModal()"
>
  <ng-template pTemplate="header">
    <div class="flex flex-column">
      <img
        [src]="isSuccess ? 'assets/icons/ico_check_circle.svg' : 'assets/icons/sp_alert.svg'"
        width="56"
        height="56"
        alt=""
      />
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <h1 class="t-20-600-primary text-center">
      {{ isSuccess ? successTitle : 'Darme de baja' }}
    </h1>
    <p class="t-14-500-dark mt-5 text-center">
      {{ isSuccess ? successMessage : message }}
    </p>
  </ng-template>
  <ng-template pTemplate="footer">
    <div
      class="deactivate-modal__footer"
      [class.deactivate-modal__footer--single]="isSuccess"
    >
      <p-button
        *ngIf="!isSuccess && !isBlocked"
        [outlined]="true"
        label="Cancelar"
        (click)="closeModal()"
      ></p-button>
      <p-button
        *ngIf="!isSuccess && !isBlocked"
        severity="danger"
        label="Darme de baja"
        [loading]="isDeactivating"
        [disabled]="isDeactivating"
        (click)="unsubscribeUser()"
      ></p-button>

      <p-button
        *ngIf="isBlocked"
        [outlined]="true"
        label="Entendido"
        (click)="closeModal()"
      ></p-button>
      <p-button
        *ngIf="isBlocked"
        label="Vender"
        (click)="goToSell()"
      ></p-button>

      <p-button
        *ngIf="isSuccess"
        label="Aceptar"
        (click)="acceptSuccess()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
